var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "Admin" } }, [
    !_vm.ready
      ? _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))])
      : _c(
          "section",
          { staticStyle: { padding: "10px", "font-size": "13px" } },
          [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("h4", [
                  _vm._v("Active Users (" + _vm._s(_vm.activeUsersCount) + ")")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("table", { staticClass: "table", attrs: { width: "100%" } }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.activeUsers, function(item, index) {
                  return _c("tr", [
                    _c("td", [_vm._v(_vm._s(index + 1))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(item.email))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(item.created_at))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(item.analytics.latest_active))]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "div",
                        { staticClass: "container-shops" },
                        _vm._l(item.shops, function(shop, index_) {
                          return _c(
                            "router-link",
                            {
                              key: index_,
                              attrs: {
                                to: {
                                  name: "ShopDailySaleDetail",
                                  query: {
                                    shop_id: shop.shop_id
                                  }
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(shop.name) +
                                  "\n              "
                              )
                            ]
                          )
                        }),
                        1
                      )
                    ])
                  ])
                }),
                0
              )
            ])
          ]
        )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticStyle: { "font-size": "13px" } }, [_vm._v("No.")]),
        _vm._v(" "),
        _c("th", { staticStyle: { "font-size": "13px" } }, [_vm._v("Email")]),
        _vm._v(" "),
        _c("th", { staticStyle: { "font-size": "13px" } }, [_vm._v("Created")]),
        _vm._v(" "),
        _c("th", { staticStyle: { "font-size": "13px" } }, [
          _vm._v("Latest Active")
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { "font-size": "13px" } }, [_vm._v("Shops")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b7a91a1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b7a91a1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/analytics/ShopDailySale.vue
// module id = null
// module chunks = 